<template>
  <Transition name="fade">
    <div v-if="$page.props.flash.success && show" class="absolute pointer-events-auto z-10 origin-center top-5 transform -translate-x-1/2 left-1/2 w-full flex items-center justify-between mb-8 max-w-lg bg-green-500 rounded">
      <div class="flex items-center">
        <svg class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><polygon points="0 11 2 9 7 14 18 3 20 5 7 18" /></svg>
        <div class="py-4 text-white text-sm font-medium">{{ $page.props.flash.success }}</div>
      </div>
      <button type="button" class="group mx-2 p-2 cursor-pointer" @click="remove">
        <HeroIcon name="close" class="w-5 h-5 fill-white transform transition-transform 0.5s ease-in-out group-hover:scale-125" />
      </button>
    </div>
  </Transition>
  <Transition name="fade">
    <div v-if="($page.props.flash.error || Object.keys($page.props.errors).length > 0) && show" class="absolute pointer-events-auto z-10 origin-center top-5 transform -translate-x-1/2 left-1/2 w-full flex items-center justify-between mb-8 max-w-lg bg-red-500 rounded">
      <div class="flex items-center">
        <svg class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z" /></svg>
        <div v-if="$page.props.flash.error" class="py-4 text-white text-sm font-medium">{{ $page.props.flash.error }}</div>
        <div v-else class="py-4 text-white text-sm font-medium">
          <span v-if="Object.keys($page.props.errors).length === 1">There is one form error.</span>
          <span v-else>There are {{ Object.keys($page.props.errors).length }} form errors.</span>
        </div>
      </div>
      <button type="button" class="group mx-2 p-2 cursor-pointer" @click="remove">
        <HeroIcon name="close" class="w-5 h-5 fill-white transform transition-transform 0.5s ease-in-out group-hover:scale-125" />
      </button>
    </div>
  </Transition>
</template>

<script>
import HeroIcon from '@/Shared/HeroIcon.vue'
export default {
  components: {HeroIcon},
  data() {
    return {
      show: true,
      animation: false
    }
  },
  methods: {
    remove(){
      this.$page.props.flash.error = null
      this.$page.props.errors = []
      this.$page.props.flash.success = null
      this.show = false
    },
  },
  watch: {
    '$page.props.flash': {
      handler() {
        this.show = true
        setTimeout(() => {
          this.remove()
        }, 2500)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.fade-enter-active {
  animation: fade-in .5s;
  transform-origin: left;
}
.fade-leave-active {
  animation: fade-out 0.8s;
  transform-origin: left;
}
@keyframes fade-in {
  0% {
    transform: scale(0) translateX(-50%) translateY(-400px);
    opacity: 0;
  }
  50% {
    transform: scale(1.5) translateX(-50%) translateY(-200px);
    opacity: 0.5;
  }
  100% {
    transform: scale(1) translateX(-50%) translateY(0);
    opacity: 100;
  }
}
@keyframes fade-out {
  0% {
    transform: scale(1) translateX(-50%);
    opacity: 100;
  }
  100% {
    transform: scale(0) translateX(-50%);
    opacity: 0;
  }
}
</style>
